import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from '../grid';
export const FormError = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mt: 1
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Box fontFamily="body" fontSize={1} fontStyle="italic" fontWeight="heading" width="100%" color="alert" __css={t0} {...props} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default FormError;